import React, { createContext, useCallback, useEffect, useMemo } from 'react';
import usePostGenericEvent from '@hooks/requests/generic-event.post.hook';
import useGetTimeZones from '@hooks/requests/time-zones.get.hook';
export const NewGenericEventModalContext = createContext(undefined);
export function NewGenericEventModalContextProvider(params) {
    const { timeZonesParams } = useMemo(() => {
        let timeZoneParams;
        timeZoneParams = {
            select: 'all'
        };
        return { timeZonesParams: timeZoneParams };
    }, []);
    const { save: postGenericEvent, result: savedGenericEvents } = usePostGenericEvent();
    // Load Timezones
    const { data: timeZoneList, loading: timeZonesLoading, error: timeZonesError } = useGetTimeZones(timeZonesParams);
    const modalDataInitializing = timeZonesLoading;
    const modalInitializationError = timeZonesError;
    const closeModal = useCallback(() => {
        params.onClose();
    }, []);
    useEffect(() => {
        if (savedGenericEvents) {
            params.onSave(savedGenericEvents);
        }
    }, [savedGenericEvents]);
    const contextData = useMemo(() => {
        const value = {
            modalReady: !modalDataInitializing,
            modalError: modalInitializationError !== null && modalInitializationError !== void 0 ? modalInitializationError : null,
            timeZoneList,
            closeModal,
            postGenericEvent
        };
        return value;
    }, [timeZoneList, modalDataInitializing, modalInitializationError]);
    return React.createElement(NewGenericEventModalContext.Provider, { value: contextData }, params.children);
}
